<template>
    <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
      <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 text-gray-800">Manage Clients</h2>
  
      <!-- Align Add Button to the Right -->
      <div class="flex justify-end mb-4">
        <button class="px-4 py-2 rounded-lg bg-green hover:bg-green hover:text-gray-200 text-gray-100" @click="openAddClientModal">
          Add
        </button>
      </div>
  
      <!-- Clients Table -->
      <table class="w-full text-left border-collapse">
        <thead>
          <tr>
            <th class="p-2 border-b-2">Client Name</th>
            <th class="p-2 border-b-2">Phone</th>
            <th class="p-2 border-b-2">Email</th>
            <th class="p-2 border-b-2">Joined Date</th>
            <th class="p-2 border-b-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(client, index) in clients" :key="index" class="hover:bg-gray-100">
            <td class="p-2 border-b">{{ client.name }}</td>
            <td class="p-2 border-b">{{ client.phone }}</td>
            <td class="p-2 border-b">{{ client.email }}</td>
            <td class="p-2 border-b">{{ formatDate(client.createdAt) }}</td>
            <td class="p-2 border-b">
              <button @click="viewClient(client)" class="text-blue-500 hover:text-blue-700 focus:outline-none px-2">
                <i class="fas fa-eye"></i>
              </button>
              <button @click="editClient(client)" class="text-gray-500 hover:text-gray-700 focus:outline-none px-2">
                <i class="fas fa-edit"></i>
              </button>
              <button @click="deleteClient(client)" class="text-red-500 hover:text-red-700 focus:outline-none px-2">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="clients.length === 0">
            <td colspan="5" class="text-center text-gray-500 p-4">No clients available.</td>
          </tr>
        </tbody>
      </table>
      <!-- Modals -->
      <AddClientModal v-if="isAddClientModalOpen" @closeModal="isAddClientModalOpen = false" />
      <ViewClientModal v-if="isViewClientModalOpen" :client="selectedClient" @closeModal="isViewClientModalOpen = false" />
      <EditClientModal v-if="isEditClientModalOpen" :client="selectedClient" @closeModal="isEditClientModalOpen = false" />
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  import AddClientModal from './AddClientModal.vue';
  import ViewClientModal from './ViewClientModal.vue';
  import EditClientModal from './EditClientModal.vue';
  export default {
    components: { 
      AddClientModal,
      ViewClientModal,
      EditClientModal
    },
    data(){
      return{
        isAddClientModalOpen: false,
        isViewClientModalOpen: false,
        isEditClientModalOpen: false,
        selectedClient: null,
      }
    },
    async mounted() {
      await this.fetchClients();
    },
    computed : {
    ...mapState('clients', {
      clients: state => state.clients,
    })
    },

    methods: {
      ...mapActions('clients', { fetchClients: 'fetchClients', addClient : 'addClient' }),
      openAddClientModal() {
      this.isAddClientModalOpen = true;
    },
    viewClient(client) {
      this.selectedClient = client;
      this.isViewClientModalOpen = true;
    },
    editClient(client) {
      this.selectedClient = client;
      this.isEditClientModalOpen = true;
    },
    deleteClient(orderId) {
      this.$emit('deleteitem', orderId);
    },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    }
  };
  </script>
  